<!--To add '&& allPrimaryHub.length>0' condition to '*ngIf'-->
<!--To add '&& allSecondaryHub.length>0' condition to '*ngIf'-->
<div class="right-panel" *ngIf="ownerArray.length >0">
  <div class="panel-header">
    <p class="panel-title"> Create a Network Server Group</p>
  </div>
  <div class="panel-container">
    <form name="createNS"
          class="createNS"
          #validate="ngForm"
          action="">

      <!--  Owner field-->
      <div class="createNS-row">
        <label class="widget-create-title">Owner
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [allowClear]="true"
                     #select1
                     [items]="ownerArray"
                     (select)="selectedOwner($event)"
                     (remove)="removedOwner($event)">
          </ngx-select>
        </div>
      </div>


      <div class="createNS-row">
        <label for="name"
               class="widget-create-title">Name
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="name"
               class="widget-create-content form-control"
               [ngClass]="{'nameUsedError': nameExist}"
               [(ngModel)]="networkServerGroupModel.name"
               name="name"
               required
               #nameInput
               maxlength="40"
               #name="ngModel"
               (input)="validateName(networkServerGroupModel.name, nameInput)"
               (keyup)="trimValue($event)"
               autocomplete="off"/>
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

        <!--Errors-->
        <div *ngIf="name.invalid && (name.dirty || name.touched)"
             class="alert alert-danger alert-validate">
          <div [hidden]="!name.hasError('required')">Name is required</div>
        </div>
        <div *ngIf="nameExist"
             class="alert alert-danger alert-validate">Name already exist!
        </div>

      </div>

      <!--  ProtocolVersion field-->
      <div class="createNS-row">
        <label class="widget-create-title">Protocol Version
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [items]="protocolVersions"
                     (select)="selectedProtocolVersion($event)">
          </ngx-select>
        </div>
      </div>

      <div class="createNS-row">
        <div *ngFor="let netId of networkServerGroupModel.netIds; let i = index; trackBy: trackByFn">
          <label *ngIf="i==0"
                 class="widget-create-title">NetID
            <i class="fa fa-info-circle info-text"></i>
          </label>
          <label *ngIf="i!=0"
                 class="widget-create-title">
          </label>
          <input class="widget-create-content add-ids-input"
                 [(ngModel)]="networkServerGroupModel.netIds[i]"
                 (change)="editNetId(i, $event)"
                 name="f{{i}}"
                 id="f{{i}}"
                 #netId="ngModel"
                 (input)="validateId(networkServerGroupModel.netIds[i], i)"
                 autocomplete="off">
          <button class="add-row"
                  (click)="removeNetId(inputNetId.value, i)">-
          </button>

          <!--Errors-->
          <div *ngIf="trackingPattern[i]"
               class="alert alert-danger alert-validate">NetId is not valid! It should be in format [prefix]/24 where prefix contains 6 hexadecimal characters.
          </div>
          <div *ngIf="trackingArr[i]"
               class="alert alert-danger alert-validate">Another network node with same NetID/JoinEUI already exists in the database!
          </div>
          <div *ngIf="trackingArr[i]==false && trackingPattern[i]==false && trackingCheck[i]"
               class="alert alert-danger alert-validate">You already entered this NetID!
          </div>

        </div>
        <label *ngIf="networkServerGroupModel.netIds.length == 0"
               class="widget-create-title">NetID
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <label *ngIf="networkServerGroupModel.netIds.length != 0"
               class="widget-create-title">
        </label>
        <input #inputNetId
               class="widget-create-content add-ids-input"
               name="netId"
               (input)="validation(inputNetId.value)"
               autocomplete="off">
        <button class="add-row"
                (click)="addNetId(inputNetId.value)">+
        </button>

        <!--Errors-->
        <div *ngIf="noValid"
             class="alert alert-danger alert-validate">NetId is not valid! It should be in format [prefix]/24 where prefix contains 6 hexadecimal characters..
        </div>
        <div *ngIf="netIdExist"
             class="alert alert-danger alert-validate">Another network node with same NetID/JoinEUI already exists in the database!
        </div>
        <div *ngIf="netIdExist==false && noValid==false && duplicatesExist"
             class="alert alert-danger alert-validate">You already entered this NetID!
        </div>
      </div>


      <div class="btn-area">
        <button class="custom-btn"
                (click)="backClicked()">Cancel
        </button>
        <button type="submit"
                class="custom-btn create-btn form-control"
                [disabled]="disableName
                || hasError
                || nameExist
                || duplicatesExist
                || noValid
                || noValidNsId
                || doNotHaveNetId
                || disableSaveButton
                || netIdExist
                || nsIdExist
                || patternError
                "
                (click)="addNetId(inputNetId?.value);saveNetworkServerGroup()">Save
        </button>
      </div>

    </form>
  </div>

</div>
